module.exports = __webpack_public_path__ + "media/images/components/c01-page-header/psychnet-logo-86c262be2560098703f7f8f4643f03a1.svg";